import api from "../api";
import config from "../config";

const toList = (data) => (Array.isArray(data) ? data : (data?.results ?? []));

const LEADS_PAGE_SIZE = 500;

const fetchEveryPage = async (url, params = {}) => {
  const items = [];
  let offset = 0;
  let expectedTotal = 0;
  do {
    const res = await api.get(url, {
      params: { ...params, limit: LEADS_PAGE_SIZE, offset },
    });
    if (Array.isArray(res.data)) return res.data;
    const results = res.data?.results ?? [];
    if (!results.length) break;
    items.push(...results);
    expectedTotal = res.data?.count ?? items.length;
    offset += results.length;
  } while (items.length < expectedTotal);
  return items;
};

export const leadsService = {
  myLeads: async ({ accountId } = {}) =>
    fetchEveryPage("/api/leads/my-leads/", accountId ? { account_id: accountId } : {}),

  otherLeads: async () => {
    const res = await api.get("/api/leads/other-leads/");
    return toList(res.data);
  },

  myLeadsPaged: async ({ page_size = 500 } = {}) => {
    const res = await api.get("/api/leads/my-leads/", {
      params: { page_size },
    });
    return toList(res.data);
  },

  getLeadDetail: async ({ leadId }) => {
    const res = await api.get(`/api/leads/${leadId}/`);
    return res.data?.data ?? res.data;
  },

  updateStatus: async ({ clienteId, statusId }) => {
    const res = await api.patch(`/api/leads/${clienteId}/update-status/`, {
      status: statusId,
    });
    return res.data?.data ?? res.data;
  },

  deleteLead: async ({ leadId }) => {
    await api.delete(`/api/leads/${leadId}/`);
  },

  updateLead: async ({ leadId, payload }) => {
    const res = await api.patch(
      `${config.apiBaseUrl}/api/leads/${leadId}/update/`,
      payload,
    );
    return res.data;
  },

  createLead: async ({ payload }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/leads/`, payload);
    return res.data;
  },

  createBatchMails: async ({ leads, templateGroupId, reminderDays }) => {
    const res = await api.post("/api/leads/batch-mails/", {
      leads,
      template_group: templateGroupId,
      reminder_days: reminderDays,
    });
    return res.data?.data ?? res.data;
  },

  getLeadCustomFieldValues: async ({ leadId }) => {
    const res = await api.get(`/api/leads/${leadId}/custom-fields/`);
    return res.data?.data ?? res.data;
  },
};
